@import '../../utils/chrome-header.css';
@import '../../utils/forced-colors.css';

:host {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: var(--_card-setting-width);
  min-height: var(--_card-setting-min-height);
  max-width: 100%;
  overflow: hidden;
  border: none;
  border-radius: var(--dimension-radius-125);
  background-color: var(--color-background-primary);
  box-shadow: var(--effect-shadow-elevated-sm);
}

:host::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 4;
  border-radius: inherit;
  box-shadow: var(--effect-highlight-elevated-sm);
  pointer-events: none;
}

:host(.card-setting--editing) {
  background-color: var(--color-background-bold-brand);
  box-shadow: 0 0 0 var(--dimension-stroke-width-025)
    var(--color-border-bold-brand);
}

:host(.card-setting--editing)::after {
  box-shadow: none;
}

.card-setting__header {
  flex: 0 0 auto;
  border-bottom: var(--dimension-stroke-width-012) solid var(--color-border-tertiary);
}

:host(.card-setting--editing) .card-setting__header {
  border-bottom-color: transparent;
}

.card-setting__copy {
  align-items: center;
}

ds-text.card-setting__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
}

.card-setting__actions {
  flex-shrink: 0;
}

.card-setting__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
  background-color: var(--color-background-primary);
  border-radius: 0 0 var(--dimension-radius-125) var(--dimension-radius-125);
}

:host(.card-setting--editing) .card-setting__body {
  border-radius: var(--dimension-radius-125);
}

@media (forced-colors: active) {
  :host {
    box-shadow: none;
    outline: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
    outline-offset: calc(-1 * var(--dimension-stroke-width-012));
  }

  :host::after {
    box-shadow: none;
  }
}
